export const PRODUCT_WKY_TYPE = 'haveWky';
// 闲置设备
export const PRODUCT_IDLE_TYPE = 'haveIdleDevice';
export const DEFAULT_TAB = 'sf';
export const PRODUCT_OTHER_TYPE = 'haveOther';
export const PRODUCT_X86_TYPE = 'haveX86';
export const PRODUCT_NO_TYPE = 'noneDevice';
export const X86_LITE_PRODUCT_TYPE = 'pc';

export const TITLE_MAP = {
  [PRODUCT_IDLE_TYPE]: '软件0成本入门',
  [PRODUCT_WKY_TYPE]: '我有玩客云设备',
  [PRODUCT_OTHER_TYPE]: '我有其他智能设备',
  [PRODUCT_NO_TYPE]: '购买官网设备',
  [PRODUCT_X86_TYPE]: '我有x86架构设备',
};

export const TIP_AND_MODAL_INFO = {
  [PRODUCT_WKY_TYPE]: {
    tip: '玩客云设备如何加入共享计划？',
    modalTitle: '玩客云设备如何加入共享计划？',
    modalContent:
      '<p>激活码产品可让您现有的智能硬件设备固件升级，快速加入共享计划。</p><p>针对玩客云设备，推出玩客云现金版激活码，激活设备，可让玩客云设备秒变赚钱神器！</p>',
  },
  [PRODUCT_OTHER_TYPE]: {
    tip: '其他智能硬件设备如何加入共享计划？',
    modalTitle: '其他智能硬件设备如何加入共享计划？',
    modalContent:
      '<p>网心云支持多种第三方智能硬件设备通过激活升级的形式，快速加入共享计划。</p><p>针对树莓派设备，推出树莓派3B、4B程序包，免激活，快速升级树莓派，让你的树莓派也能赚收益！</p><p>针对FX/WJY设备，推出三方盒子激活码，激活设备后，可让FX/WJY设备秒变赚钱神器！</p>',
  },
  [PRODUCT_NO_TYPE]: {
    tip: '通过网心云官方设备如何加入共享计划？',
    modalTitle: '通过网心云官方硬件设备加入共享计划',
    modalContent:
      '<p>网心云推出官方智能硬件设备赚钱宝系列，免激活免安装，连接网络和闲置硬盘即可享受现金收益，适合新手用户。</p>',
  },
  [PRODUCT_X86_TYPE]: {
    tip: '其他智能硬件设备如何加入共享计划？',
    modalTitle: '其他智能硬件设备如何加入共享计划？',
    modalContent:
      '<p>网心云支持多种第三方智能硬件设备通过激活升级的形式，快速加入共享计划。</p><p>针对树莓派设备，推出树莓派3B、4B程序包，免激活，快速升级树莓派，让你的树莓派也能赚收益！</p><p>针对FX/WJY设备，推出三方盒子激活码，激活设备后，可让FX/WJY设备秒变赚钱神器！</p>',
  },
};

export const OVERVIEW_STEPS_INFO = [
  {
    title: '第一步  选择硬件设备加入共享计划',
    img: 'step_1',
  },
  {
    title: '第二步 激活升级设备',
    img: 'step_2',
  },
  {
    title: '第三步 查看收益',
    img: 'income',
  },
];

export const PRODUCTS_INFO = [
  {
    type: PRODUCT_NO_TYPE,
    title: TITLE_MAP[PRODUCT_NO_TYPE],
    summary: '网心云官网售卖设备，即买即用，省心方便',
    image: PRODUCT_NO_TYPE,
    url: `/guide/product?type=${PRODUCT_NO_TYPE}`,
    tag: '省心套餐',
  },
  {
    type: PRODUCT_IDLE_TYPE,
    title: TITLE_MAP[PRODUCT_IDLE_TYPE],
    summary: '安装软件快速体验，让你的手机、电脑“赚起来”',
    image: PRODUCT_IDLE_TYPE,
    url: `/guide/product?type=${PRODUCT_IDLE_TYPE}`,
    tag: '免费试玩',
  },
  {
    type: PRODUCT_X86_TYPE,
    title: TITLE_MAP[PRODUCT_X86_TYPE],
    summary: '支持x86服务器、电脑、NAS等设备，500M上行使用，单台收益最高',
    image: PRODUCT_X86_TYPE,
    url: `/guide/product?type=${PRODUCT_X86_TYPE}`,
    tag: '连续在线享收益+10%',
  },
  {
    type: PRODUCT_WKY_TYPE,
    title: TITLE_MAP[PRODUCT_WKY_TYPE],
    summary: '只需1个激活码，设备秒变赚钱神器',
    image: PRODUCT_WKY_TYPE,
    url: `/guide/product?type=${PRODUCT_WKY_TYPE}`,
    tag: '玩客推荐',
  },
  {
    type: PRODUCT_OTHER_TYPE,
    title: TITLE_MAP[PRODUCT_OTHER_TYPE],
    summary: '支持树莓派/FX/WJY/docker等设备，收益更客观',
    image: PRODUCT_OTHER_TYPE,
    url: `/guide/product?type=${PRODUCT_OTHER_TYPE}`,
    tag: '专业玩家推荐',
  },
];
